export const metersToCentimeters = (target: number | undefined): number | undefined => {
    if (target === null || target === undefined) {
        return undefined;
    }
    return Math.round(target * 100 * 100) / 100;
};
